import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './taskForm';
import List from './taskList';

const settings = {
    pathRegister: paths.taskRegister,
    pathList: paths.task,
    apiPath: 'tasks',
    permissionAdmin: null,
    title: 'Tarefa',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Tarefas' }} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
